import { BaseModel } from ".";

export interface Role extends BaseModel {
    name: string;
    claims: string[];
}

export enum Roles {
    Admin = 'Administrator',
    Company = 'Company',
    Instructor = 'Instructor',
    Student = 'Student',
    Client = 'Client',
    Member = 'Member'
}